export const RETRIEVE_SUPPLIER_CUSTOMERS = 'RETRIEVE_SUPPLIER_CUSTOMERS';
export const SUPPLIER_CUSTOMER_PAGE_SIZE = 'SUPPLIER_CUSTOMER_PAGE_SIZE';
export const SUPPLIER_CUSTOMER_PAGE_NUMBER = 'SUPPLIER_CUSTOMER_PAGE_NUMBER';
export const SUPPLIER_CUSTOMER_ORDER_BY = 'SUPPLIER_CUSTOMER_ORDER_BY';
export const SUPPLIER_CUSTOMER_DIRECTION = 'SUPPLIER_CUSTOMER_DIRECTION';
export const SUPPLIER_ACCOUNT_CHOSEN = 'SUPPLIER_ACCOUNT_CHOSEN';